import { APP_BRANDING_CONFIG_SERVICE, IAppBrandingConfigService } from '../app-branding-config';
import { applyColorOnBody } from './branding.utils';
import { IAppBrandingConfig } from '../../interfaces';
import { IBrandingService } from './branding.interface';
import { inject, injectable } from 'inversify';

@injectable()
export class BrandingService implements IBrandingService {

    @inject(APP_BRANDING_CONFIG_SERVICE) private readonly brandSrv: IAppBrandingConfigService;

    setup(): Promise<void> {
        return this.brandSrv.get()
            .then((config: IAppBrandingConfig) => config.color)
            .then(applyColorOnBody);
    }
}
